import React, { Component, useState, useEffect, useRef, useLayoutEffect } from 'react'

import { AnimatePresence, motion, useMotionValue, useTransform, animate, useScroll, useMotionValueEvent, useAnimationControls, motionValue } from "framer-motion"

import { NavLink, Link } from "react-router-dom"

import Modal from 'react-modal';

import IconButton from '../../elements/IconButton'
import Dropdown from '../../elements/ReactSelectDropdown'
import TextInput from '../../elements/TextInput'
import Button from '../../elements/Button'

import Add from '../../media/icons/icons8-add-96.png'

const Main = (props) => {

    const dealers = [
        { value: '4 Season Motors', label: '4 Season Motors' },
        { value: 'Chopper City', label: 'Chopper City' },
        { value: 'Auto Station', label: 'Auto Station' },
        { value: 'Duke City Auto LLC', label: 'Duke City Auto LLC' },
        { value: 'Pitre Buick GMC', label: 'Pitre Buick GMC' },
        { value: 'Sunset Motors', label: 'Sunset Motors' },
        { value: 'Speedy Wheels', label: 'Speedy Wheels' },
        { value: 'Elite Autos', label: 'Elite Autos' },
        { value: 'Golden Motors', label: 'Golden Motors' },
        { value: 'Thunder Auto', label: 'Thunder Auto' },
        { value: 'Cityscape Cars', label: 'Cityscape Cars' },
        { value: 'Majestic Motors', label: 'Majestic Motors' },
        { value: 'Eagle Eye Autos', label: 'Eagle Eye Autos' },
        { value: 'Sprint Auto Solutions', label: 'Sprint Auto Solutions' },
        { value: 'Grand Prix Motors', label: 'Grand Prix Motors' },
        { value: 'Royal Wheels', label: 'Royal Wheels' },
        { value: 'Pinnacle Cars', label: 'Pinnacle Cars' },
        { value: 'Prime Drive', label: 'Prime Drive' },
        { value: 'Dynamic Motors', label: 'Dynamic Motors' },
        { value: 'Precision Auto', label: 'Precision Auto' },
        { value: 'Evergreen Vehicles', label: 'Evergreen Vehicles' },
        { value: 'Blue Ribbon Autos', label: 'Blue Ribbon Autos' },
        { value: 'Safari Motors', label: 'Safari Motors' },
        { value: 'Vanguard Auto', label: 'Vanguard Auto' },
        { value: 'Velocity Motors', label: 'Velocity Motors' },
        { value: 'Omega Cars', label: 'Omega Cars' },
        { value: 'Supreme Autos', label: 'Supreme Autos' },
        { value: 'Victory Vehicles', label: 'Victory Vehicles' },
        { value: 'Zenith Motors', label: 'Zenith Motors' }
    ]
    
    const [newSpiffeeData, setNewSpiffeeData] = useState(props.selectedSpiffee)

    const onChange = (e, type) => {
        setNewSpiffeeData((newSpiffeeData) => {return {...newSpiffeeData, [type]: e}})
    }

    return (
        <div style={{width: '715px', height: 'auto', display: 'flex', flexDirection: 'column'}}>
            <div style={{flexBasis: '10%', display: 'flex', flexDirection: 'row'}}>
                <span style={{fontWeight: '500', fontSize: '20px', flexBasis: '99%'}}>Edit Report</span>
                <IconButton img={false} colors={props.colors} Style={{borderRadius: '3px', backgroundColor: props.colors.border}} size="16px">
                    <div onClick={props.setIsOpen} style={{paddingLeft: '3px', paddingRight: '3px'}}><span onClick={props.setIsOpen}>x</span></div>
                </IconButton>
            </div>
            <div style={{flexBasis: '37%', display: 'flex', flexDirection: 'column', marginTop: '20px'}}>
                <div style={{width: '100%', display: 'flex', flexDirection: 'row'}}>
                    <div style={{width: '48%', display: 'flex', flexDirection: 'column'}}>
                        <span style={{marginBottom: '5px', fontWeight: '500'}}>Report Type</span>
                        <Dropdown data={dealers} colors={props.colors}></Dropdown>
                        <span style={{marginTop: '20px', marginBottom: '5px', fontWeight: '500'}}>Admin</span>
                        <Dropdown data={dealers} colors={props.colors}></Dropdown>
                        <span style={{marginTop: '20px', marginBottom: '5px', fontWeight: '500'}}>Quantity</span>
                        <TextInput colors={props.colors} prefix='' data='0'></TextInput>
                    </div>
                    <div style={{width: '48%', display: 'flex', flexDirection: 'column', marginLeft: '4%'}}>
                        <span style={{marginBottom: '5px', fontWeight: '500'}}>Dealer</span>
                        <Dropdown data={dealers} colors={props.colors}></Dropdown>
                        <span style={{marginTop: '20px', marginBottom: '5px', fontWeight: '500'}}>Contract Type</span>
                        <Dropdown data={dealers} colors={props.colors}></Dropdown>
                    </div>
                </div>
            </div>
            <div style={{height: 'auto', display: 'flex', flexDirection: 'column', marginTop: '20px'}}>
                <div className='center' style={{backgroundColor: props.colors.block, width: '100%', height: '49px', border: '1px solid ' + props.colors.border, borderTopRightRadius: '5px', borderTopLeftRadius: '5px', display: 'flex', flexDirection: 'row'}}>
                    <div style={{display: 'flex', flexDirection: 'row'}}>
                        <span style={{fontWeight: '600', marginTop: '7px'}}>Spiffees</span>
                        <IconButton image={Add} size={26} Style={{backgroundColor: props.colors.primary, marginLeft: '20px'}} colors={props.colors}></IconButton>
                    </div>
                </div>
                <div style={{width: '100%', border: '1px solid ' + props.colors.border, display: 'flex', flexDirection: 'row', padding: '2%'}}>
                    <div style={{width: '48%', display: 'flex', flexDirection: 'column'}}>
                        <span style={{marginBottom: '5px', fontWeight: '500'}}>Spiffee</span>
                        <Dropdown data={dealers} colors={props.colors}></Dropdown>
                        <span style={{marginTop: '20px', marginBottom: '5px', fontWeight: '500'}}>Shipping Address</span>
                        <Dropdown data={dealers} colors={props.colors}></Dropdown>
                    </div>
                    <div style={{width: '48%', display: 'flex', flexDirection: 'column', marginLeft: '4%'}}>
                        <span style={{marginBottom: '5px', fontWeight: '500'}}>Amount / Contract</span>
                        <Dropdown data={dealers} colors={props.colors}></Dropdown>
                        <span style={{marginTop: '20px', marginBottom: '5px', fontWeight: '500'}}>Spiff Type</span>
                        <Dropdown data={dealers} colors={props.colors}></Dropdown>
                    </div>
                </div>
            </div>
            <div style={{height: 'auto', display: 'flex', flexDirection: 'column', marginTop: '20px'}}>
                <div className='center' style={{backgroundColor: props.colors.block, width: '100%', height: '49px', border: '1px solid ' + props.colors.border, borderTopRightRadius: '5px', borderTopLeftRadius: '5px'}}>
                    <div style={{display: 'flex', flexDirection: 'row'}}>
                        <span style={{fontWeight: '600', marginTop: '7px'}}>Reserve Inputs</span>
                        <IconButton image={Add} size={26} Style={{backgroundColor: props.colors.primary, marginLeft: '20px'}} colors={props.colors}></IconButton>
                    </div>
                </div>
                <div style={{width: '100%', border: '1px solid ' + props.colors.border, display: 'flex', flexDirection: 'row', padding: '2%'}}>
                    <div style={{width: '48%', display: 'flex', flexDirection: 'column'}}>
                        <span style={{marginBottom: '5px', fontWeight: '500'}}>Account</span>
                        <Dropdown data={dealers} colors={props.colors}></Dropdown>
                    </div>
                    <div style={{width: '48%', display: 'flex', flexDirection: 'column', marginLeft: '4%'}}>
                        <span style={{marginBottom: '5px', fontWeight: '500'}}>Amount</span>
                        <Dropdown data={dealers} colors={props.colors}></Dropdown>
                    </div>
                </div>
            </div>
            <Button colors={props.colors} active={true} Style={{marginTop: '15px', width: '200px', marginLeft: 'auto'}}>Save</Button>
        </div>
    )
}

export default Main
